<template>
  <section class="content">
    <vue-headful title="QB-STATISTICS | Benutzer"></vue-headful>
    <div class="modal fade" id="addUserModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Add new User</h4>
          </div>
          <ValidationObserver v-slot="{ invalid }">
          <div class="modal-body">
            <div v-if="errorWhileCreating" class="alert alert-danger alert-dismissible">
              <button type="button" class="close" data-dismiss="alert" aria-hidden="true" @click="errorWhileCreating = false">×</button>
              <h4><i class="icon fa fa-warning mr-5"></i>Achtung!</h4>
              Es gibt folgende Fehler:
              <ul>
                <li v-for="err in Object.keys(errors)">
                  {{err}}: {{typeof errors[err] === 'string' ? errors[err] : errors[err][0] }}
                </li>
              </ul>
            </div>
            <form class="form-horizontal">
                <ValidationProvider rules="required|email" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="email" class="control-label col-sm-4">E-mail:</label>
                    <div class="col-sm-8">
                      <input class="form-control has-error" v-model="newUser.email" type="text" id="email"/>
                      <span class="text-danger">{{errors[0]}}</span>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider v-slot="{errors, untouched}" rules="required">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="username" class="control-label col-sm-4">Username:</label>
                    <div class="col-sm-8">
                      <input class="form-control" v-model="newUser.username" type="text" id="username"/>
                      <span class="text-danger">{{errors[0]}}</span>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="password|required" v-slot="{errors, untouched}" vid="pass">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="password" class="control-label col-sm-4">Password:</label>
                    <div class="col-sm-8">
                      <input class="form-control" type="text" v-model="newUser.password" id="password"/>
                      <span class="text-danger">{{errors[0]}}</span>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider v-slot="{errors, untouched}" rules="confirmed:pass">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="verifyPassword" class="control-label col-sm-4">Verify Password:</label>
                    <div class="col-sm-8">
                      <input class="form-control" type="text" id="verifyPassword"/>
                      <span class="text-danger">{{errors[0]}}</span>
                    </div>
                  </div>
                </ValidationProvider>
                <add-role-to-user-row :options="possibleRoles" :roles="newUser.roles" @select="updateProp($event, newUser)"></add-role-to-user-row>
                <ValidationProvider v-slot="{errors, untouched}" rules="required">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="firstName" class="control-label col-sm-4">First Name:</label>
                    <div class="col-sm-8">
                      <input class="form-control" v-model="newUser.first_name" type="text" id="firstName"/>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider v-slot="{errors, untouched}" rules="required">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="lastName" class="control-label col-sm-4">Last Name:</label>
                    <div class="col-sm-8">
                      <input class="form-control" v-model="newUser.last_name" type="text" id="lastName"/>
                    </div>
                  </div>
                </ValidationProvider>
                <div class="form-group">
                  <label for="type" class="control-label col-sm-4">Type:</label>
                  <div class="col-sm-8">
                    <select class="form-control" v-model="newUser.type">
                      <template v-for="option in userTypes">
                        <option v-if="option.value !== 'all'" :value="option.value">{{option.value}}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label for="isActive" class="control-label col-sm-4">Status:</label>
                  <div class="checkbox">
                    <label><input disabled type="checkbox" v-model="newUser.is_active">Active</label>
                  </div>
                </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="myBtn"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="invalid" @click="saveData(newUser, 'post')">Save<i class="fa fa-save ml-5"></i></button>
          </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editUserModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Edit User</h4>
          </div>
          <div class="nav-tabs-custom no-margin">
            <!--<ul class="nav nav-tabs pull-right">
              <li :class="[enableEdit ? 'active' : '']" v-if="!checkIfDisabled(userForUpdate.id, 'update')"><button @click="()=>{enableEdit = true}" type="button" class="btn"><i class="fa fa-pencil mr-5"></i>Edit Mode</button></li>
              <li :class="[enableEdit ? '' : 'active']"><button @click="()=>{enableEdit = false}" aria-expanded="true" type="button" class="btn"><i class="fa fa-eye mr-5"></i>View Mode</button></li>
            </ul>-->
            <ul class="nav nav-tabs pull-right">
              <li class=""><a href="#editMode" data-toggle="tab" aria-expanded="false" @click="enableEdit = true"><i class="fa fa-pencil mr-5"></i>Edit Mode</a></li>
              <li class="active"><a href="#viewMode" data-toggle="tab" aria-expanded="true" @click="enableEdit = false"><i class="fa fa-eye mr-5"></i>View Mode</a></li>
            </ul>
          </div>
          <div class="modal-body">
            <div v-if="errorWhileCreating" class="alert alert-danger alert-dismissible">
              <button type="button" class="close" data-dismiss="alert" aria-hidden="true" @click="errorWhileCreating = false">×</button>
              <h4><i class="icon fa fa-warning mr-5"></i>Achtung!</h4>
              Es gibt folgende Fehler:
              <ul>
                <li v-for="err in Object.keys(errors)">
                  {{err}}: {{typeof errors[err] === 'string' ? errors[err] : errors[err][0] }}
                </li>
              </ul>
            </div>
            <div class="tab-content">
              <!-- VIEW MODE -->
              <div class="tab-pane active" id="viewMode">
                <div class="form-horizontal">
                  <div class="form-group">
                    <label for="firstName" class="control-label col-sm-4">First Name:</label>
                    <div class="col-sm-8 control-label text-left"><span>{{userForUpdate.first_name}}</span></div>
                  </div>
                  <div class="form-group">
                    <label for="lastName" class="control-label col-sm-4">Last Name:</label>
                    <div class="col-sm-8 control-label text-left"><span>{{userForUpdate.last_name}}</span></div>
                  </div>
                  <div class="form-group">
                    <label for="email" class="control-label col-sm-4">E-Mail:</label>
                    <div class="col-sm-8 control-label text-left"><span>{{userForUpdate.email}}</span></div>
                  </div>
                  <div class="form-group">
                    <label for="username" class="control-label col-sm-4">Username:</label>
                    <div class="col-sm-8 control-label text-left"><span>{{userForUpdate.username}}</span></div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-4">Roles:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span v-for="r in userForUpdate.roles" class="label label-success">{{r.value}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-4">Type:</label>
                    <div class="col-sm-8 control-label text-left"><span>{{userForUpdate.type}}</span></div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-4">Status:</label>
                    <div class="col-sm-8 control-label text-left">
                      <label v-if="userForUpdate.is_active" class="label label-success"><i class="fa fa-check mr-5"></i>Active</label>
                      <label v-else class="label label-danger"><i class="fa fa-ban mr-5"></i>Inactive</label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- EDIT MODE -->
              <div class="tab-pane" id="editMode">
                <!--<div class="alert alert-warning alert-dismissible">
                  <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                  <h4><i class="icon fa fa-warning mr-5"></i>Edit carefully!</h4>
                  Mistakes will be punished with immediate execution ;)
                </div>-->
                <form action="#" method="post" class="form-horizontal">
                  <div class="form-group">
                    <label for="editFirstName" class="control-label col-sm-4">First Name:</label>
                    <div class="col-sm-8"><input type="text" id="editFirstName" placeholder="First Name" class="form-control" v-model="userForUpdate.first_name"></div>
                  </div>
                  <div class="form-group">
                    <label for="editLastName" class="control-label col-sm-4">Last Name:</label>
                    <div class="col-sm-8"><input type="text" id="editLastName" placeholder="Last Name" class="form-control" v-model="userForUpdate.last_name"></div>
                  </div>
                  <div class="form-group">
                    <label for="editEmail" class="control-label col-sm-4">E-Mail:</label>
                    <div class="col-sm-8"><input type="text" id="editEmail" placeholder="E-Mail" class="form-control" v-model="userForUpdate.email"><span class="text-danger"></span></div>
                  </div>
                  <div class="form-group">
                    <label for="editUsername" class="control-label col-sm-4">Username:</label>
                    <div class="col-sm-8"><input type="text" id="editUsername" placeholder="Username" class="form-control" v-model="userForUpdate.username"><span class="text-danger"></span></div>
                  </div>
                  <div class="form-group">
                    <label for="editPassword" class="control-label col-sm-4">Password:</label>
                    <div class="col-sm-8"><input type="password" id="editPassword" placeholder="Password" class="form-control" v-model="userForUpdate.password"><span class="text-danger"></span></div>
                  </div>
                  <div class="form-group">
                    <label for="editVerifyPassword" class="control-label col-sm-4">Verify Password:</label>
                    <div class="col-sm-8"><input type="password" id="editVerifyPassword" placeholder="Verify Password" class="form-control"><span class="text-danger"></span></div>
                  </div>
                  <add-role-to-user-row :options="rolesForUpdate" :roles="userForUpdate.roles" @select="updateProp($event, userForUpdate)"></add-role-to-user-row>
                  <div class="form-group">
                    <label for="editType" class="control-label col-sm-4">Type:</label>
                    <div class="col-sm-8">
                      <select class="form-control" v-model="userForUpdate.type" id="editType">
                        <template v-for="option in userTypes">
                          <option v-if="option.value !== 'all'" :value="option.value">{{option.value}}</option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="activeState" class="control-label col-sm-4"></label>
                    <div class="col-sm-offset-4 col-sm-8">
                      <div class="checkbox">
                        <label class="text-success no-padding"><input type="radio" name="activeState" v-model="userForUpdate.is_active" value="true">&nbsp;&nbsp;Active</label>
                        <label class="text-danger"><input type="radio" name="activeState" v-model="userForUpdate.is_active" value="false">&nbsp;&nbsp;Inactive</label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeEdit"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button v-if="enableEdit" type="submit" class="btn btn-primary" @click="saveData(userForUpdate, 'put')">Save<i class="fa fa-save ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-danger fade" id="disableUserModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Disable User</h4>
          </div>
          <div class="modal-body">
            <h3 class="text-center">
              Are you sure you want to disable the user "{{userForDelete.value}}"?
            </h3>
          </div>
          <div class="modal-footer text-left">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeDelete"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-danger" @click="onOk">Disable<i class="fa fa-ban ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">User Configuration</h3>
        <div class="box-tools">
          <div class="btn-group">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="box-toolbar">
          <div class="btn-group">
            <button v-if="showButton" type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#addUserModal" @click="addToProps"><i class="fa fa-plus mr-5"></i>Add new User</button>
          </div>
          <links-box></links-box>
        </div>
        <b-table :items="items" :fields="fields">
          <template v-slot:cell(value)="data">
            <p class="mb-0 text-bold">{{data.item.value}}</p>
          </template>
          <template v-slot:cell(modify)="data">
            <button :disabled="checkIfDisabled(data.item.id, 'read')" class="btn btn-default btn-sm" @click="updateUser(data.item.id)" data-toggle="modal" data-target="#editUserModal"><i class="fa fa-pencil mr-5"></i>Bearbeiten</button>
          </template>
          <template v-slot:cell(delete)="data">
            <button :disabled="checkIfDisabled(data.item.id, 'delete')" class="btn btn-danger btn-sm" @click="deleteUser(data.item)" data-toggle="modal" data-target="#disableUserModal"><i class="fa fa-ban mr-5"></i>Löschen</button>
          </template>
        </b-table>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import Api from '@/services/Api'
  export default {
    name: "AdminEdit",
    data () {
      return {
        errors: {},
        fields: [
          {key: 'id', label: 'User ID'},
          {key: 'value', label: 'Username'},
          {key: '', label: 'Roles'},
          {key: '', label: 'Status'},
          {key: 'modify', label: 'Edit'},
          {key: 'delete', label: 'Change Status'},
        ],
        errorWhileCreating: false,
        enableEdit: false,
        userPermissions: this.$store.getters.permissions,
        userForUpdate: {
          roles: []
        },
        userForDelete: '',
        showButton: false,
        msOptions: [],
        properties: [],
        possibleRoles: [],
        rolesForUpdate: [],
        selectedProp: '',
        selectedName: '',
        items: [],
        fullOptions: [],
        newUser: {
          roles: [],
          password: '',
          is_active: true
        },
        userTypes: [],
        creating: false
      }
    },
    methods: {
      getData () {
          axios.all([Api().get(`/accounting/user/list`), Api().get('/frontend/permission/userType?action=read')])
          .then(axios.spread((...res) => {
            this.items = res[0].data
            this.userTypes = res[1].data
          }))
          .catch(errors => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
          })
      },
      addToProps () {
        Api().get('/accounting/role/list')
        .then(res => {
          this.possibleRoles = res.data
          this.newUser.type = this.userTypes[0].value
          this.creating = true
          this.selectedName = ''
        })
      },
      updateProp (prop, target) {
        target.roles = prop
        /*prop.forEach(p => {
          if (!target.roles.includes(p)) {
            target.roles.push(p)
          }
        })*/
      },
      deleteUser (user) {
        this.userForDelete = user
      },
      onOk () {
        Api().delete(`/accounting/user?id=${this.userForDelete.id}`)
          .then(res => {
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success!',
              text: 'User Deleted Successfully'
            });
            Api().get(`/accounting/user/list`)
              .then(response => {
                this.userForDelete = {}
                this.items = response.data
                this.$refs.closeDelete.click()
              })
          })
          .catch(error => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
            this.confirmOpen = false
          })
      },
      saveData (target, method) {
        if (target.roles.length > 0 && typeof target.roles[0] === 'object') {
          let roles = []
            target.roles.forEach(r => {
              roles.push(r.id)
            })
          target.roles = roles
        }
        target.roles = typeof target.roles === 'string' ? target.roles : target.roles.join(',')
        target.is_active = target.is_active ? 1 : 0
        Api()({method: method, url: `/accounting/user`, data:target})
          .then(res => {
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success!',
              text: method === 'post' ? 'User Created Successfully' : 'User Updated Successfully'
            });
            if (method === 'post') {
              Api().get(`/accounting/user/list`)
                .then(response => {
                  this.newUser = {}
                  this.items = response.data
                  this.$refs.myBtn.click()
                })
            } else {
              this.userForUpdate = {}
              this.$refs.closeEdit.click()
            }
            this.creating = false
            this.getData()
          })
          .catch(error => {
            this.errorWhileCreating = true
            this.errors = error.response.data.errors || error.response.data.message
          })
      },
      /*saveProp () {
        this.newUser.roles = this.newUser.roles.join(',')
        this.newUser.is_active = this.newUser.is_active ? 1 : 0
        Api().post(`/accounting/user`, this.newUser)
        .then(response => {
          this.getData()
        })
        .catch(error => {
          console.log(error)
        })
      },*/
      updateUser (id) {
        axios.all([Api().get(`/accounting/user?id=${id}`),  Api().get('accounting/role/list')])
        .then(axios.spread((...res) => {
          this.userForUpdate = res[0].data
          this.rolesForUpdate = res[1].data
        })).catch(error => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
        })
      },
      checkIfDisabled (id, action) {
        if (action in this.userPermissions.user) {
          let a = this.userPermissions.user[action].find(x => parseInt(x.value) ? parseInt(x.value) : x.value === id || x.value === 'all')
          return typeof a === 'undefined'
        }
        return true
      }
    },
    beforeCreate() {
      this.$store.dispatch('userHasPermission', {type: 'user', action: 'create', scope: 'all'})
      .then(res => {
        this.showButton = res
      })
    },
    mounted () {
      this.getData()
    }
  }
</script>

